// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Subscription Details Container */
.sub-details {
    width: 100%;
    max-width: 1150px;
    margin: 3rem auto;
    padding: 1rem;
    font-family: var(--ff-primary);
}

/* Title styling */
.sub-title {
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 2rem;
    color: var(--clr-primary-5);
}

.plan-header {
    display: flex;
    align-items: center; 
    gap: 10px; 
  }
  
  .plan-header input[type="radio"] {
    transform: scale(1.3); 
    cursor: pointer;
  }
  
  .plan-header h4 {
    font-size: 1.6rem;
    color: var(--clr-grey-1);
    font-weight: bold;
    text-transform: uppercase;
    margin: 0; 
    padding: 0.5rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border-radius: var(--radius);
  }
  
/* Pricing Cards Section */
.sub-pricing-container {
    display: flex;
    justify-content: space-between;
    gap: 1.5rem;
    flex-wrap: wrap;
}

.sub-pricing-card {
    background: var(--clr-white);
    border: 1px solid var(--clr-primary-5);
    border-radius: var(--radius);
    padding: 2rem;
    width: 30%;
    box-shadow: var(--light-shadow);
    text-align: center;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: var(--transition);
    transition: background-color 0.3s ease, box-shadow 0.3s ease; /* Added color transition */
    cursor: pointer;
}

/* Highlight Plan Name - Using Accent Bar */
.sub-pricing-card h4 {
    font-size: 1rem;
    color: var(--clr-grey-1);
    margin-bottom: 1rem;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.5rem;
    position: relative;
    background-color: var(--clr-primary-5); 
    color: var(--clr-white); 
    border-radius: var(--radius);
}

.sub-pricing-card section {
    text-align: left;
    margin: 1rem 0;
}

.sub-pricing-card section h5 {
    color: var(--clr-grey-2);
    font-size: 1rem;
    margin-bottom: 0.5rem;
}

.sub-pricing-card ul {
    list-style-type: none;
    padding: 0;
}

.sub-pricing-card ul li {
    margin-bottom: 0.5rem;
    color: var(--grey-700);
}

/* Radio Button Styling */
.sub-pricing-card input[type="radio"] {
    margin-bottom: 1rem;
    margin-right: 10px; 
    transform: scale(1.3); 
    cursor: pointer;
}

/* Hover Effects */
.sub-pricing-card:hover {
    transform: scale(1.05);
    box-shadow: var(--dark-shadow);
    background-color: var(--clr-primary-7); 
}

/* Selected Plan Style */
.sub-pricing-card.selected {
    border: 3px solid var(--clr-primary-5); 
    background-color: var(--clr-primary-9); 
    box-shadow: var(--dark-shadow);
}

/* Card Buttons positioned at the bottom */
.sub-card-buttons {
    margin-top: auto;
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.sub-btn-card {
    display: block;
    margin: 0 auto;
    width: 80%;
    padding: 0.75rem;
    border-radius: var(--radius);
    border: none;
    cursor: pointer;
    background-color: var(--clr-primary-5);
    transition: var(--transition);
}

.sub-demo-btn {
    background-color: var(--clr-primary-10);
}

.sub-btn-card:hover,
.sub-demo-btn:hover {
    background-color: var(--clr-white);
}

/* Page Buttons */
.sub-form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
}

.sub-btn-page {
    width: 45%;
    padding: 1rem;
    border-radius: var(--radius);
    border: none;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    cursor: pointer;
    transition: var(--transition);
}

.sub-btn-page:hover {
    background-color: var(--clr-primary-4);
}

/* Animations */
@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.sub-pricing-card {
    animation: fadeInUp 0.6s ease-out;
}

/* Responsive styling */
@media (max-width: 768px) {
    .sub-pricing-container {
        flex-direction: column;
        align-items: center;
    }

    .sub-pricing-card {
        width: 100%;
    }
}

/* Comparison Container */
.comparison-container {
    margin-top: 3rem;
    background: var(--grey-50);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    animation: fadeInUp 0.8s ease-out; 
}

/* Title Styling */
.comparison-title {
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    color: var(--clr-primary-5);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    border-bottom: 2px solid var(--clr-primary-5);
    padding-bottom: 1rem;
}

/* Comparison Grid */
.comparison-grid {
    display: grid;
    grid-template-columns: 1fr repeat(3, 1fr);
    gap: 1rem;
    opacity: 0;
    animation: fadeIn 0.8s ease-out 0.5s forwards; 
}

.feature-row {
    display: contents;
}

.feature-name {
    background: var(--grey-200);
    color: var(--grey-800);
    padding: 1.2rem;
    text-align: left;
    font-weight: bold;
    border: 1px solid var(--grey-300);
    display: flex;
    align-items: center;
    transition: background-color 0.3s ease;
}

.feature-value {
    background: var(--clr-white);
    color: var(--clr-primary-5);
    padding: 1.2rem;
    text-align: center;
    font-weight: bold;
    border: 1px solid var(--grey-300);
    transition: background-color 0.3s ease, transform 0.3s ease;
}

/* Hover Effects */
.feature-row:hover .feature-name,
.feature-row:hover .feature-value {
    background-color: var(--clr-primary-9);
    transform: translateY(-2px);
    box-shadow: var(--light-shadow);
}

/* Add Icons to Feature Names */
.feature-name:before {
    content: "✔️";
    font-size: 1.2rem;
    margin-right: 0.75rem;
    color: var(--clr-primary-5);
}

/* Alternating Row Backgrounds */
.feature-row:nth-child(even) .feature-name,
.feature-row:nth-child(even) .feature-value {
    background: var(--grey-100);
}

/* Responsive styling for mobile */
@media (max-width: 768px) {
    .comparison-grid {
        grid-template-columns: 1fr;
    }

    .feature-value {
        text-align: left;
    }
}

/* Fade-in Animation */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

.icon {
    margin-right: 0.5rem;
    color: var(--clr-primary-1); /* Adjust this to match your theme */
  }
  
.tick-icon {
    margin-right: 0.5rem;
    color: var(--clr-grey-2); 
  }

 .tick-icon :hover
  {
      color: var(--clr-white);
  }

`, "",{"version":3,"sources":["webpack://./src/components/registration-multi-step-forms/SubscriptionDetails.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC,uBAAuB;IACvB,4BAA4B;EAC9B;;AAEF,0BAA0B;AAC1B;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,4BAA4B;IAC5B,aAAa;IACb,UAAU;IACV,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,4DAA4D,EAAE,2BAA2B;IACzF,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,sCAAsC;IACtC,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,wBAAwB;AACxB;IACI,sCAAsC;IACtC,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,sCAAsC;IACtC,uBAAuB;IACvB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,yCAAyC;IACzC,SAAS;IACT,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;IACjC,2DAA2D;AAC/D;;AAEA,kBAAkB;AAClB;;IAEI,sCAAsC;IACtC,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,gCAAgC;AAChC;;IAEI,2BAA2B;AAC/B;;AAEA,kCAAkC;AAClC;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,2BAA2B,EAAE,oCAAoC;EACnE;;AAEF;IACI,oBAAoB;IACpB,wBAAwB;EAC1B;;CAED;;MAEK,uBAAuB;EAC3B","sourcesContent":["/* Subscription Details Container */\n.sub-details {\n    width: 100%;\n    max-width: 1150px;\n    margin: 3rem auto;\n    padding: 1rem;\n    font-family: var(--ff-primary);\n}\n\n/* Title styling */\n.sub-title {\n    text-align: center;\n    font-size: 1.8rem;\n    margin-bottom: 2rem;\n    color: var(--clr-primary-5);\n}\n\n.plan-header {\n    display: flex;\n    align-items: center; \n    gap: 10px; \n  }\n  \n  .plan-header input[type=\"radio\"] {\n    transform: scale(1.3); \n    cursor: pointer;\n  }\n  \n  .plan-header h4 {\n    font-size: 1.6rem;\n    color: var(--clr-grey-1);\n    font-weight: bold;\n    text-transform: uppercase;\n    margin: 0; \n    padding: 0.5rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border-radius: var(--radius);\n  }\n  \n/* Pricing Cards Section */\n.sub-pricing-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.sub-pricing-card {\n    background: var(--clr-white);\n    border: 1px solid var(--clr-primary-5);\n    border-radius: var(--radius);\n    padding: 2rem;\n    width: 30%;\n    box-shadow: var(--light-shadow);\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transition: var(--transition);\n    transition: background-color 0.3s ease, box-shadow 0.3s ease; /* Added color transition */\n    cursor: pointer;\n}\n\n/* Highlight Plan Name - Using Accent Bar */\n.sub-pricing-card h4 {\n    font-size: 1rem;\n    color: var(--clr-grey-1);\n    margin-bottom: 1rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    padding: 0.5rem;\n    position: relative;\n    background-color: var(--clr-primary-5); \n    color: var(--clr-white); \n    border-radius: var(--radius);\n}\n\n.sub-pricing-card section {\n    text-align: left;\n    margin: 1rem 0;\n}\n\n.sub-pricing-card section h5 {\n    color: var(--clr-grey-2);\n    font-size: 1rem;\n    margin-bottom: 0.5rem;\n}\n\n.sub-pricing-card ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.sub-pricing-card ul li {\n    margin-bottom: 0.5rem;\n    color: var(--grey-700);\n}\n\n/* Radio Button Styling */\n.sub-pricing-card input[type=\"radio\"] {\n    margin-bottom: 1rem;\n    margin-right: 10px; \n    transform: scale(1.3); \n    cursor: pointer;\n}\n\n/* Hover Effects */\n.sub-pricing-card:hover {\n    transform: scale(1.05);\n    box-shadow: var(--dark-shadow);\n    background-color: var(--clr-primary-7); \n}\n\n/* Selected Plan Style */\n.sub-pricing-card.selected {\n    border: 3px solid var(--clr-primary-5); \n    background-color: var(--clr-primary-9); \n    box-shadow: var(--dark-shadow);\n}\n\n/* Card Buttons positioned at the bottom */\n.sub-card-buttons {\n    margin-top: auto;\n    padding-top: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.sub-btn-card {\n    display: block;\n    margin: 0 auto;\n    width: 80%;\n    padding: 0.75rem;\n    border-radius: var(--radius);\n    border: none;\n    cursor: pointer;\n    background-color: var(--clr-primary-5);\n    transition: var(--transition);\n}\n\n.sub-demo-btn {\n    background-color: var(--clr-primary-10);\n}\n\n.sub-btn-card:hover,\n.sub-demo-btn:hover {\n    background-color: var(--clr-white);\n}\n\n/* Page Buttons */\n.sub-form-buttons {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 2rem;\n}\n\n.sub-btn-page {\n    width: 45%;\n    padding: 1rem;\n    border-radius: var(--radius);\n    border: none;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.sub-btn-page:hover {\n    background-color: var(--clr-primary-4);\n}\n\n/* Animations */\n@keyframes fadeInUp {\n    0% {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.sub-pricing-card {\n    animation: fadeInUp 0.6s ease-out;\n}\n\n/* Responsive styling */\n@media (max-width: 768px) {\n    .sub-pricing-container {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .sub-pricing-card {\n        width: 100%;\n    }\n}\n\n/* Comparison Container */\n.comparison-container {\n    margin-top: 3rem;\n    background: var(--grey-50);\n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    animation: fadeInUp 0.8s ease-out; \n}\n\n/* Title Styling */\n.comparison-title {\n    text-align: center;\n    font-size: 1.8rem;\n    margin-bottom: 1.5rem;\n    color: var(--clr-primary-5);\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    border-bottom: 2px solid var(--clr-primary-5);\n    padding-bottom: 1rem;\n}\n\n/* Comparison Grid */\n.comparison-grid {\n    display: grid;\n    grid-template-columns: 1fr repeat(3, 1fr);\n    gap: 1rem;\n    opacity: 0;\n    animation: fadeIn 0.8s ease-out 0.5s forwards; \n}\n\n.feature-row {\n    display: contents;\n}\n\n.feature-name {\n    background: var(--grey-200);\n    color: var(--grey-800);\n    padding: 1.2rem;\n    text-align: left;\n    font-weight: bold;\n    border: 1px solid var(--grey-300);\n    display: flex;\n    align-items: center;\n    transition: background-color 0.3s ease;\n}\n\n.feature-value {\n    background: var(--clr-white);\n    color: var(--clr-primary-5);\n    padding: 1.2rem;\n    text-align: center;\n    font-weight: bold;\n    border: 1px solid var(--grey-300);\n    transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n/* Hover Effects */\n.feature-row:hover .feature-name,\n.feature-row:hover .feature-value {\n    background-color: var(--clr-primary-9);\n    transform: translateY(-2px);\n    box-shadow: var(--light-shadow);\n}\n\n/* Add Icons to Feature Names */\n.feature-name:before {\n    content: \"✔️\";\n    font-size: 1.2rem;\n    margin-right: 0.75rem;\n    color: var(--clr-primary-5);\n}\n\n/* Alternating Row Backgrounds */\n.feature-row:nth-child(even) .feature-name,\n.feature-row:nth-child(even) .feature-value {\n    background: var(--grey-100);\n}\n\n/* Responsive styling for mobile */\n@media (max-width: 768px) {\n    .comparison-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .feature-value {\n        text-align: left;\n    }\n}\n\n/* Fade-in Animation */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeIn {\n    to {\n        opacity: 1;\n    }\n}\n\n.icon {\n    margin-right: 0.5rem;\n    color: var(--clr-primary-1); /* Adjust this to match your theme */\n  }\n  \n.tick-icon {\n    margin-right: 0.5rem;\n    color: var(--clr-grey-2); \n  }\n\n .tick-icon :hover\n  {\n      color: var(--clr-white);\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
